var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true || _vm.channel && _vm.channel.isLoaded)?_c('div',[_c('div',{staticClass:"d21-language-select"},[_c('d21-select',{attrs:{"list":this.languages}})],1),_c('Cancellation',{attrs:{"Channel":_vm.channel}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }